import type { ProjectPhaseStatus } from "@buildpy/core/modules/project/types";

// 공정 상태 글자색·차트 실적 막대색 — 공정 카드·차트·랜딩 그림이 한 벌을 쓴다(클라이언트 컴포넌트를 딸려 오지 않게 따로 둔다).
export const PHASE_STATUS_CLASS: Record<ProjectPhaseStatus, string> = {
  PENDING: "text-muted-foreground",
  ACTIVE: "text-status-progress",
  DONE: "text-status-done",
  HOLD: "text-status-hold",
};

export const PHASE_ACTUAL_BAR_CLASS: Record<ProjectPhaseStatus, string> = {
  PENDING: "bg-status-hold",
  ACTIVE: "bg-primary",
  DONE: "bg-status-done",
  HOLD: "bg-status-hold",
};
